// AccountManagerChips.tsx
import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import { useAccountManagerStore } from "@/stores/accountManagerStore"

interface AccountManagerChipsProps {
  accountManagers: string[] | undefined
  onRemove: (key: keyof any, value: string) => void
}

export const AccountManagerChips: React.FC<AccountManagerChipsProps> = ({ accountManagers, onRemove }) => {
  const accountManagerOptions = useAccountManagerStore((state) => state.visibleManagers)

  const accountManagerNames = useMemo(
    () =>
      accountManagers
        ?.map((id: string) => {
          const manager = accountManagerOptions.find((m) => m.userId === id)
          return manager ? `${manager.firstName} ${manager.lastName}` : ""
        })
        .filter(Boolean) || [],
    [accountManagers, accountManagerOptions]
  )

  return useMemo(
    () =>
      accountManagerNames.map((name, idx) => (
        <FilterChip
          key={`${name}-${idx}`}
          label={`Manager: ${name}`}
          onDelete={() => onRemove("accountManagers", accountManagers![idx])}
        />
      )),
    [accountManagerNames, accountManagers, onRemove]
  )
}
